/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ICollectionWithCounts } from '../collection-schema';
import { collectionWithCountsSchema } from '../collection-schema';

export const getCollectionResponseSchema = createApiResponseSchema(
  collectionWithCountsSchema,
) as import('zod').ZodSchema<IAPI<ICollectionWithCounts>>;

export type IGetCollectionResponse = IAPI<ICollectionWithCounts>;
